import axios from 'axios'

const DEFAULT_RETRY_OPTIONS = {
  maxRetries: 3,
  statusCodes: [422, 500],
  retryDelay: 1000,
}

export const axiosWithRetries = async ({
  url,
  method = 'get',
  options = {}, // axios options
  retryOptions = DEFAULT_RETRY_OPTIONS
}) => {
  let attempt = 0

  while (attempt < retryOptions.maxRetries) {
    try {
      return await axios[method](url, options)
    } catch (error) {
      attempt++

      if(
        !retryOptions.statusCodes.includes(error.response?.status)
        || attempt === retryOptions.maxRetries
      ) {
        throw error;
      }

      await new Promise(resolve => setTimeout(resolve, retryOptions.retryDelay))
    }
  }
}
